export const recs = {
  channel: "9",
};
